import { render } from "./AutomacaoPage.vue?vue&type=template&id=708b0a23&scoped=true"
import script from "./AutomacaoPage.vue?vue&type=script&lang=js"
export * from "./AutomacaoPage.vue?vue&type=script&lang=js"

import "./AutomacaoPage.vue?vue&type=style&index=0&id=708b0a23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708b0a23"]])

export default __exports__